import { QUERY_KEY } from './useRecentlyViewedCompanies';
export { default as useRecentlyViewedCompanies } from './useRecentlyViewedCompanies';
export const DASHBOARD_RECENTLY_VIEWED_QUERY_KEY = QUERY_KEY;
